interface IMockedOperationPost {
  description: string
  isActive: boolean
  id: number
  projectIds: number[]
}

export const mockedOperationPosts: IMockedOperationPost[] = [
  {
    projectIds: [38, 39, 40],
    description: 'Operations Post: BIL.PUMPER',
    isActive: true,
    id: 209,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.CAT',
    isActive: true,
    id: 210,
  },
  {
    projectIds: [38, 40],
    description: 'Operations Post: BIL.ULEB',
    isActive: true,
    id: 211,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.CHUB',
    isActive: true,
    id: 212,
  },
  {
    projectIds: [39, 40],
    description: 'Operations Post: BIL.NA',
    isActive: true,
    id: 213,
  },
  {
    projectIds: [38, 39, 40],
    description: 'Operations Post: BIL.NON.PERMITTED',
    isActive: true,
    id: 214,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.RACK',
    isActive: true,
    id: 215,
  },
  {
    projectIds: [39, 40],
    description: 'Operations Post: BIL.KCOB.SENIOR',
    isActive: true,
    id: 216,
  },
  {
    projectIds: [39, 40],
    description: 'Operations Post: BIL.PATCH',
    isActive: true,
    id: 217,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.U2',
    isActive: true,
    id: 218,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.BOHO',
    isActive: true,
    id: 219,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.HYBL',
    isActive: true,
    id: 220,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.OCC',
    isActive: true,
    id: 221,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.HCBL',
    isActive: true,
    id: 222,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.LAB',
    isActive: true,
    id: 223,
  },
  {
    projectIds: [40],
    description: 'Operations Post: BIL.GAUGER',
    isActive: true,
    id: 224,
  },
]
